import { SxProps, Theme } from '@mui/material';

// Section header label ("Billing cycle" / "Copier" / "Add-ons"). Single source
// of truth so every section overline in the drawer renders identically.
export const SECTION_LABEL_SX: SxProps<Theme> = {
  display: 'block',
  color: 'text.secondary',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 1.2,
  lineHeight: 1
};

// All-caps mini chip used for "Active" / "Most popular" overlays
// across Tiers and Addons cards. Hoisted so the sx object identity
// stays stable across renders.
export const CHIP_OVERLINE_SX: SxProps<Theme> = {
  height: 16,
  fontSize: 9,
  textTransform: 'uppercase',
  letterSpacing: '0.12em',
  '& .MuiChip-label': { fontWeight: 700, px: 0.625 }
};

// "Cancel subscription" / "Remove from plan" under an owned card: a danger-red text button, below the CTA in weight.
// ::before (::after is the theme's press flash) grows the 28px button's tap area to 44px without moving the layout.
export const CANCEL_LINK_BUTTON_SX: SxProps<Theme> = {
  textTransform: 'none',
  letterSpacing: 0,
  fontSize: 11.5,
  fontWeight: 600,
  lineHeight: 1.2,
  px: 0.75,
  ml: -0.75,
  minWidth: 0,
  '&::before': { content: '""', position: 'absolute', inset: '-8px 0' }
};

// Dialogs opened from inside the checkout drawer must stack above it.
export const ABOVE_DRAWER_SX: SxProps<Theme> = { zIndex: (theme) => theme.zIndex.drawer + 1100 };
